import { Col } from 'react-bootstrap';
import FacilityDetailedInformation from './FacilityDetailedInformation';
import { t } from 'i18next';

const RightSection = ({
  locationHandler,
  affiliatedDoctorsHandler,
  facilityDetails,
  addressIndex,
}) => {
  return (
    <>
      <Col sm={9} className="mt-5 mt-md-0">
        <div className="details-section secondary-background">
          <div className="tabs-section">
            <FacilityDetailedInformation
              locationHandler={locationHandler}
              facilityDetails={facilityDetails}
              addressIndex={addressIndex}
            >
              {/*Once API data available we use click event */}
              <p
                className="provider-details-data"
                onClick={() => {
                  affiliatedDoctorsHandler();
                }}
              >
                <span className="secondary-2 cursor-pointer">
                  {t('find_provider.see_all_affiliated_doctors')}
                </span>
              </p>
            </FacilityDetailedInformation>
          </div>
        </div>
      </Col>
    </>
  );
};
export default RightSection;
